"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var Science_1 = require("../components/Science/Science");
var targetNode = document.querySelector('.science-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(Science_1.default, null), targetNode);
}
